import RiveComponent, { RiveAlignment } from '../../RiveComponent'
import RenderHTML from '../../ui-components/RenderHTML'
import { getBottomPadding } from '../../../utils/sessionStorage'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { useEffect } from 'react'
import { TerminalStatusContext } from '../../../types/mf-execution.types'

export const Loading = ({
  title,
  caption,
  titleClassName,
  statusContext
}: {
  title: string
  caption?: string
  titleClassName?: string
  statusContext?: TerminalStatusContext
}) => {
  const getScreenName = () => {
    switch (statusContext) {
      case TerminalStatusContext.AUTO_PAY:
        return 'Autopay_setup_loading'
      default:
        return 'Payment loading'
    }
  }

  useEffect(() => {
    trackEvent({
      eventName: EventNames.ScreenLoaded,
      payload: {
        ScreenName: getScreenName(),
        eventId: `${statusContext}`
      }
    })
  }, [statusContext])

  return (
    <div
      style={{ paddingBottom: `calc(${getBottomPadding()}px + 8px)` }}
      className='flex flex-col h-full w-full bg-white px-5 pt-[35vh]'
    >
      {/* Three bouncing circles */}
      <div className='flex mt-3 h-16 w-16'>
        <RiveComponent
          src={`/rives/mf-execution/awaiting.riv`}
          alignment={RiveAlignment.CENTER_LEFT}
          fallback={<LoadingFallback />}
        />
      </div>

      {/* Text */}
      <div
        className={
          titleClassName
            ? `text-[#232323] text-left mt-4 ${titleClassName}`
            : 'text-[28px] font-[500] text-[#232323] leading-[150%] text-left mt-4'
        }
      >
        <RenderHTML innerHTMLText={title} />
      </div>

      {caption && (
        <div className='text-[14px] font-[400] text-[#6A6E6E] leading-[160%] text-left mt-auto'>
          <RenderHTML innerHTMLText={caption} />
        </div>
      )}
    </div>
  )
}

export const LoadingFallback = () => {
  return (
    <div className='flex space-x-2 mt-3 h-max mt-auto'>
      {[0, 1, 2].map((index) => (
        <div
          key={index}
          className='w-3 h-3 bg-[#136FCC] rounded-full animate-bounce'
          style={{
            animationDelay: `${index * 0.2}s`,
            animationDuration: '1s',
            animationIterationCount: 'infinite'
          }}
        />
      ))}
    </div>
  )
}
